import { SubText } from '@procurify/ui'

import { type ConversationCatalogItemDelivery } from '../../value-objects/ConversationTurnItem'
import { ConversationRichText } from '../ConversationRichText'

export interface ICatalogItemDeliveryLabelProps {
  delivery: ConversationCatalogItemDelivery
  noWrap?: boolean
}

export const CatalogItemDeliveryLabel = ({
  delivery,
  noWrap = false,
}: ICatalogItemDeliveryLabelProps) => (
  <SubText inline noWrap={noWrap} color='textSecondary'>
    <ConversationRichText content={delivery.label} />
  </SubText>
)
